import { Link } from 'react-router-dom';
import { Alert, Box, Heading, Spinner, Table } from '@hyphen/hyphen-components';

import { useResource } from '../lib/session.js';
import { exportURL } from '../lib/api.js';

/** The control catalogue. */
export function ControlsList() {
  const { data: records, error } = useResource('/controls');

  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!records) return <Spinner />;

  const columns = [
    {
      heading: 'Control',
      dataKey: 'hai_id',
      width: 110,
      render: (_cell, row) => <Link to={`/admin/controls/${row.hai_id}`}>{row.hai_id}</Link>,
    },
    { heading: 'Control text', dataKey: 'control' },
  ];

  return (
    <Box gap="3xl">
      <Box direction="row" alignItems="center" gap="xl">
        <Heading as="h1" size="lg">Controls</Heading>
        <Box direction="row" alignItems="baseline" gap="xl" style={{ marginLeft: 'auto' }}>
          <Box as="span" fontSize="sm" color="tertiary">Export</Box>
          {/* Links rather than buttons: these navigate to a file. */}
          <a className="export-link" href={exportURL('markdown')}>Markdown</a>
          <a className="export-link" href={exportURL('xlsx')}>Excel</a>
        </Box>
      </Box>

      <Table rowKey="hai_id" columns={columns} rows={records} isScrollable={{ x: true }} />
    </Box>
  );
}
